/**
 * FastAPI 422 `detail` kan vara sträng, lista med {msg,loc,...}, eller objekt — sonner/toast kräver sträng.
 */
export function formatApiErrorMessage(error, fallback = "") {
  const d = error?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((x) => {
        if (typeof x === "string") return x;
        if (x && typeof x.msg === "string") return x.msg;
        return "";
      })
      .filter(Boolean)
      .join(" ");
  }
  if (d && typeof d === "object" && typeof d.msg === "string") return d.msg;
  return fallback;
}
